module.exports = __webpack_public_path__ + "img/fanpage.141940ae.svg";